// @flow

import { useTranslator } from '@gandi/translate';
import { Base, Button, Heading } from '@gandi/ui';

import styles from './AddAllButton.scss';

type Props = {
  title?: string,
  onClick: () => Promise<any>,
  loading: boolean,
};

export function AddAllButton({
  title,
  loading,
  onClick,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Base
      flex
      {...(title ? { flexJustifyBetween: true } : { flexJustifyEnd: true })}
      className={styles.root}
    >
      {!!title && (
        <Heading as="h2" fontSize="l">
          {title}
        </Heading>
      )}
      <Button
        className={styles.button}
        iconBefore="cart"
        type="button"
        kind="ghost"
        loading={loading}
        onClick={onClick}
      >
        {__('Add all')}
      </Button>
    </Base>
  );
}
